import BaseModel from './BaseModel'
import {makeObservable, observable} from 'mobx'

export default class CompanyQuery extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      page_number: observable,
      page_count: observable,
      count: observable,
      country_id: observable,
      name: observable,
      sports: observable
    })
  }

  page_number = 1;
  page_count = 1;
  count = 0;
  country_id = null;
  name = '';
  sports = [];
}